import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import axios from "axios";

import { Form, Layout, Input, message, AutoComplete, Button } from "antd";
import cronosLogo from "../../images/cronos-logo-blue.svg";
import { CREATE_UNVERIFIED_USER_MUTATION } from "../../helpers/graphql/auth";
import { signInPath } from "../../helpers/paths";

interface CreateUserFormValues {
  githubId: string;
}

export function SignUp() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [options, setOptions] = useState<{ value: string }[]>([]);

  const [createUser, { loading }] = useMutation(CREATE_UNVERIFIED_USER_MUTATION, {
    onCompleted: ({ createUser }) => {
      if (createUser) {
        message.success("User created, please wait for the admin approval", 4);
        navigate(signInPath());
      }
    },
  });

  const handleSubmit = async (values: CreateUserFormValues) => {
    createUser({
      variables: values,
    });
  };

  const renderOptions = (login: string, avatar_url: string) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {login}
        <span>
          <img alt={"icon"} src={avatar_url} style={{ height: 20 }} />
        </span>
      </div>
    );
  };

  let delayTimer: any;
  const onSearch = (searchText: string) => {
    clearTimeout(delayTimer);
    if (!searchText) {
      setOptions([]);
    } else {
      delayTimer = setTimeout(async function () {
        axios.get(`https://api.github.com/search/users?q=${searchText}+in:login`).then((result) => {
          result.data.items.map((_: any) => {
            _.label = renderOptions(_.login, _.avatar_url);
            _.value = _.login;
            return _;
          });
          setOptions(result.data.items || []);
        });
      }, 2000);
    }
  };

  return (
    <Layout className="auth-content-wrapper">
      <div className="auth-content">
        <div className="logo">
          <img src={cronosLogo} alt="cronos" />
        </div>

        <Form<CreateUserFormValues>
          id="createProjectForm"
          name="createProject"
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item label="Github ID" name="githubId" required>
            <AutoComplete options={options} onSelect={() => {}} onSearch={onSearch}>
              <Input placeholder="Github ID" />
            </AutoComplete>
          </Form.Item>
          <Form.Item label="Email on Github" name="email" required>
            <Input placeholder="Email" />
          </Form.Item>

          <Form.Item>
            <Button
              form="createProjectForm"
              key="submit"
              htmlType="submit"
              type="primary"
              style={{ backgroundColor: "#000", width: "-webkit-fill-available" }}
              loading={loading}
            >
              Sign up
            </Button>
          </Form.Item>
          <Button
            type="text"
            style={{ width: "-webkit-fill-available" }}
            onClick={() => navigate(signInPath())}
          >
            Sign in instead?
          </Button>
        </Form>
      </div>

      <div className="auth-footer">Powered by CronosLabs &copy; 2022</div>
    </Layout>
  );
}
